import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=5fb7fa25"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "./Footer.vue?vue&type=style&index=0&id=5fb7fa25&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fb7fa25')) {
      api.createRecord('5fb7fa25', component.options)
    } else {
      api.reload('5fb7fa25', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=5fb7fa25", function () {
      api.rerender('5fb7fa25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/vertical/Footer.vue"
export default component.exports